// | See <https://docs.manca.ro/Field_tests.html>.
import * as $runtime from "../runtime.js";
import * as Data$dEnum from "../Data.Enum/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dUnfoldable1 from "../Data.Unfoldable1/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Effect$dRandom$dWeighted from "../Effect.Random.Weighted/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Restaumatic$dAnalytics$dTypes$dEvent from "../Restaumatic.Analytics.Types.Event/index.js";
import * as Restaumatic$dServices$dStorage from "../Restaumatic.Services.Storage/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Utils$dTracking from "../Utils.Tracking/index.js";
const member = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = false;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare(k)(v._3);
        if (v1.tag === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1.tag === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1.tag === "EQ") {
          go$c = false;
          go$r = true;
          continue;
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const weight = dict => dict.weight;
const storageKey = "fieldTestExperiments";
const randomVariant = dictExperimentVariant => Effect$dRandom$dWeighted.weightedRandom(x => Data$dInt.toNumber(dictExperimentVariant.weight(x)))((() => {
  const $0 = dictExperimentVariant.Bounded0();
  return Data$dEnum.enumFromTo(dictExperimentVariant.Enum1())(Data$dUnfoldable1.unfoldable1Array)($0.bottom)($0.top);
})());
const getAllExperimentVariants = /* #__PURE__ */ (() => {
  const $0 = Data$dMap$dSerialized.monoidMap(Data$dOrd.ordString).mempty;
  const $1 = Restaumatic$dServices$dStorage.getJSONItem(Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Data$dMap$dSerialized.asJSONKeyString)(Foreign$dGeneric$dClass.stringDecode)({
    decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.readString}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  }))(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)("fieldTestExperiments");
  return () => {
    const a$p = $1();
    return (() => {
      if (a$p.tag === "Nothing") { return $0; }
      if (a$p.tag === "Just") { return a$p._1; }
      $runtime.fail();
    })();
  };
})();
const experimentsSentToAnalytics = /* #__PURE__ */ (() => {
  const $0 = Data$dSet.monoidSet(Data$dOrd.ordString).mempty;
  return () => ({value: $0});
})()();
const experimentName = dict => dict.experimentName;
const encode = dictExperimentVariant => dictExperimentVariant.Show2().show;
const setExperimentVariant = dictExperimentVariant => {
  const encode1 = dictExperimentVariant.Show2().show;
  return value => {
    const name = dictExperimentVariant.experimentName(Type$dProxy.Proxy);
    return () => {
      const variants = getAllExperimentVariants();
      return Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback._2("fieldTestExperiments")(Foreign$dInternal$dStringify.unsafeStringify(Data$dMap$dSerialized.encodeMap(Data$dMap$dSerialized.asJSONKeyString)(Foreign$dGeneric$dClass.stringEncode)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      }).encode(Data$dMap$dInternal.insert(Data$dOrd.ordString)(name)(encode1(value))(variants))))();
    };
  };
};
const decode = dictExperimentVariant => {
  const encode1 = dictExperimentVariant.Show2().show;
  const $0 = dictExperimentVariant.Bounded0();
  const allEnumValues = Data$dEnum.enumFromTo(dictExperimentVariant.Enum1())(Data$dUnfoldable1.unfoldable1Array)($0.bottom)($0.top);
  return s => Data$dFoldable.find(Data$dFoldable.foldableArray)(x => encode1(x) === s)(allEnumValues);
};
const getExperimentVariant = dictExperimentVariant => {
  const decode1 = decode(dictExperimentVariant);
  const encode1 = dictExperimentVariant.Show2().show;
  const randomVariant1 = randomVariant(dictExperimentVariant);
  const name = dictExperimentVariant.experimentName(Type$dProxy.Proxy);
  return () => {
    const variants = getAllExperimentVariants();
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(name)(variants);
    const m_variant = (() => {
      if ($0.tag === "Just") { return decode1($0._1); }
      if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    const v = (() => {
      if (m_variant.tag === "Just") {
        Effect$dConsole.log("[FieldTest] Experiment " + name + ": already chose variant " + encode1(m_variant._1))();
        return m_variant._1;
      }
      if (m_variant.tag === "Nothing") {
        const v = randomVariant1();
        Effect$dConsole.log("[FieldTest] Experiment " + name + ": selecting and saving variant " + encode1(v))();
        Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback._2("fieldTestExperiments")(Foreign$dInternal$dStringify.unsafeStringify(Data$dMap$dSerialized.encodeMap(Data$dMap$dSerialized.asJSONKeyString)(Foreign$dGeneric$dClass.stringEncode)({
          encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
        }).encode(Data$dMap$dInternal.insert(Data$dOrd.ordString)(name)(encode1(v))(variants))))();
        return v;
      }
      $runtime.fail();
    })();
    const sent = experimentsSentToAnalytics.value;
    const $1 = member(name)(sent);
    const $2 = Restaumatic$dAnalytics$dTypes$dEvent.$Event("ExperienceImpression", {experiment: name, variant: encode1(v)});
    if (!$1) {
      const currency = Utils$dTracking.getCurrencyEff();
      Utils$dTracking.trackEventEff(Utils$dTracking.toNamedEvent(currency)($2))();
      const $3 = experimentsSentToAnalytics.value;
      experimentsSentToAnalytics.value = Data$dMap$dInternal.insert(Data$dOrd.ordString)(name)()($3);
    } else if ($1) {

    } else {
      $runtime.fail();
    }
    return v;
  };
};
const clearVariant = dictExperimentVariant => v => {
  const name = dictExperimentVariant.experimentName(Type$dProxy.Proxy);
  return () => {
    const variants = getAllExperimentVariants();
    return Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback._2("fieldTestExperiments")(Foreign$dInternal$dStringify.unsafeStringify(Data$dMap$dSerialized.encodeMap(Data$dMap$dSerialized.asJSONKeyString)(Foreign$dGeneric$dClass.stringEncode)({
      encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
    }).encode(Data$dMap$dInternal.delete(Data$dOrd.ordString)(name)(variants))))();
  };
};
export {
  clearVariant,
  decode,
  encode,
  experimentName,
  experimentsSentToAnalytics,
  getAllExperimentVariants,
  getExperimentVariant,
  member,
  randomVariant,
  setExperimentVariant,
  storageKey,
  weight
};
